export function ProductMetaForm({
  handle,
  title,
  description,
  sizeChart,
  metadescription,
  madeToOrderProduct,
  estimatedOrderArrival,
  setHandle,
  setTitle,
  setDescription,
  setSizeChart,
  setMetadescription,
  setMadeToOrderProduct,
  setEstimatedOrderArrival,
}: {
  handle: string;
  title: string;
  description: string;
  sizeChart: string;
  metadescription: string;
  madeToOrderProduct: string;
  estimatedOrderArrival: string;
  setHandle: (handle: string) => void;
  setTitle: (title: string) => void;
  setDescription: (description: string) => void;
  setSizeChart: (sizeChart: string) => void;
  setMetadescription: (sizeChart: string) => void;
  setMadeToOrderProduct: (sizeChart: string) => void;
  setEstimatedOrderArrival: (sizeChart: string) => void;
}) {
  return (
    <div>
      <div className="mt-4">
        <label
          htmlFor="title"
          className="block text-sm font-medium text-gray-700"
        >
          Product Handle
        </label>
        <div className="mt-1">
          <input
            type="text"
            name="product_handle"
            id="product_handle"
            value={handle}
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            onChange={(e) => setHandle(e.target.value)}
          />
        </div>
      </div>
      <div className="mt-4">
        <label
          htmlFor="title"
          className="block text-sm font-medium text-gray-700"
        >
          Product Title
        </label>
        <div className="mt-1">
          <input
            type="text"
            name="product_title"
            id="product_title"
            value={title}
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
      </div>
      <div className="mt-4">
        <label
          htmlFor="description"
          className="block text-sm font-medium text-gray-700"
        >
          Product Description
        </label>
        <div className="mt-1">
          <textarea
            name="product_description"
            id="product_description"
            rows={4}
            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="mt-4">
          <label
            htmlFor="metadescription"
            className="block text-sm font-medium text-gray-700"
          >
            Description
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="metadescription"
              id="metadescription"
              className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={metadescription}
              onChange={(e) => setMetadescription(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4">
          <label
            htmlFor="size_chart"
            className="block text-sm font-medium text-gray-700"
          >
            Size Chart
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="size_chart"
              id="size_chart"
              className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={sizeChart}
              onChange={(e) => setSizeChart(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4">
          <label
            htmlFor="madeToOrderProduct"
            className="block text-sm font-medium text-gray-700"
          >
            Made To Order Product
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="madeToOrderProduct"
              id="madeToOrderProduct"
              className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={madeToOrderProduct}
              onChange={(e) => setMadeToOrderProduct(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4">
          <label
            htmlFor="estimatedOrderArrival"
            className="block text-sm font-medium text-gray-700"
          >
            Estimated Order Arrival
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="estimatedOrderArrival"
              id="estimatedOrderArrival"
              className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={estimatedOrderArrival}
              onChange={(e) => setEstimatedOrderArrival(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
